import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { injectIntl } from 'react-intl'
import { compose } from 'recompose'
import { meta, routerAdapter, tableCommon } from 'helpers/decorators'

import {
  awardsProgressOverview as awardsProgressOverviewApi
} from 'redux/modules/api'
import { logError } from 'redux/modules/app'
import AjEventsFilter from '../../../../constants/filter-enums/aj-events'
import { personId } from '../../../../utils/token'


function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      meta({
        title: 'Awards Progress Overview',
        intlKey: 'pageTitle.awards_progress_overview'
      }),
      routerAdapter(),
      withRouter,
      injectIntl,
      tableCommon(),

    connect(
        ({ api, app }) => ({
          awardsProgressOverview: api.awardsProgressOverview,
          commonLimit: app.commonLimit
        }),
        {
          ...awardsProgressOverviewApi,
          logError
        }
      )
    )

    class AwardsProgressOverview extends Component {
      static propTypes = {
        intl: PropTypes.object.isRequired,
        params: PropTypes.object.isRequired,
        awardsProgressOverview: PropTypes.object.isRequired,
        setAwardsProgressOverviewFilter: PropTypes.func.isRequired,
        setAwardsProgressOverviewParams: PropTypes.func.isRequired,
        getAwardsProgressOverview: PropTypes.func.isRequired,
        getAwardsProgressOverviewCount: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        commonLimit: PropTypes.number,
        exportAwardProgressOverview: PropTypes.func.isRequired,
      }

      static defaultProps = {
        params: {}
      }

      constructor(props) {
        super(props)
        this.key = uuid.v1()
      }

      componentDidMount() {
        const { commonLimit, setAwardsProgressOverviewParams, awardsProgressOverview } = this.props

        if (config.useCommonLimit && commonLimit) {
          setAwardsProgressOverviewParams({ limit: commonLimit })
        }
        else {
          config.list &&
          this.handleGetAwardsProgressOverview(awardsProgressOverview)
        }
      }

      componentWillReceiveProps(nextProps) {
        const { awardsProgressOverview } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.awardsProgressOverview

        if (
          awardsProgressOverview.filter !== filter ||
          awardsProgressOverview.limit !== limit ||
          awardsProgressOverview.offset !== offset ||
          awardsProgressOverview.sort !== sort ||
          awardsProgressOverview.invalidate !== invalidate
        ) {

          const reloadCount=
            awardsProgressOverview.filter !== filter || awardsProgressOverview.invalidate !== invalidate

          config.list &&
          this.handleGetAwardsProgressOverview(nextProps.awardsProgressOverview, reloadCount)
        }
      }

      componentWillUnmount() {
      }


      handleGetAwardsProgressOverview = (awardsProgressOverview, reloadCount) => {
        this.props
          .getAwardsProgressOverview(awardsProgressOverview)
          .catch(this.handleError)

        reloadCount && this.props
          .getAwardsProgressOverviewCount(awardsProgressOverview)
          .catch(this.handleError)
      }


      handleError = err => {
        console.log('error', err.body && err.body.bodyMessage)
        this.props.logError(err)
      }

      handleExportAwardProgressOverview = () => {
        const { awardsProgressOverview } = this.props

        return this.props
          .exportAwardProgressOverview(awardsProgressOverview)
          .catch(this.handleError)
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            key={this.key}
            exportAwardProgressOverview={this.handleExportAwardProgressOverview}
          />
        )
      }
    }

    return enhance(AwardsProgressOverview)
  }
}

export default decorator
